import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '漫画大全', to: '/category/all' },
  { label: '恋爱', to: '/category/romance' },
  { label: '奇幻', to: '/category/fantasy' },
  { label: '悬疑', to: '/category/mystery' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (to: string) => {
    if (to === '/') return pathname === '/';
    return pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur-md border-b border-background-200/70">
      <nav className="mx-auto flex h-16 items-center justify-between px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="5177漫画网首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 font-display text-lg">
              漫
            </span>
            <span className="font-display text-xl md:text-2xl tracking-wide">
              <span className="text-primary-600">5177</span>
              <span className="text-foreground-950">漫画网</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors ${
                  isActive(item.to)
                    ? 'text-primary-600 bg-primary-100/70 font-medium'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/comic/tent-secret"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-4 py-2 text-sm whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            <i className="ri-book-open-line text-base" aria-hidden="true" />
            免费阅读
          </Link>
          <button
            type="button"
            className="md:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100"
            onClick={() => setOpen(!open)}
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`px-3 py-2.5 rounded-md text-sm ${
                  isActive(item.to)
                    ? 'text-primary-600 bg-primary-100/70 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/comic/tent-secret"
              onClick={() => setOpen(false)}
              className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-4 py-2.5 text-sm whitespace-nowrap"
            >
              <i className="ri-book-open-line text-base" aria-hidden="true" />
              免费阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}